import { createFileRoute } from "@tanstack/react-router";
import SpravatoOlderAdults from "@/pages/SpravatoOlderAdults";
export const Route = createFileRoute("/spravato-for-older-adults")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SPRAVATO® for Older Adults | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SPRAVATO® for older adults with depression at Neuro Wellness in Coral Springs, FL. FDA-cleared esketamine for seniors with treatment-resistant depression.",
        },
        {
          property: "og:title",
          content: "SPRAVATO® for Older Adults | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SPRAVATO® for older adults with depression at Neuro Wellness in Coral Springs, FL. FDA-cleared esketamine for seniors with treatment-resistant depression.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/spravato-for-older-adults",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/spravato-for-older-adults",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SpravatoOlderAdults />;
}
